import request from '@/utils/request'
export function info(id) {
  return request({
    url: `api/app/result/${id}/student`,
    data:{
      id
    }
  })
}

export function save(data){
  return request({
    url: data.id?`api/app/result/${data.id}/student`: 'api/app/result/student',
    data,
    method: data.id ? 'PUT':'POST',
    json: true
  })
}



// WEBPACK FOOTER //
// ./src/api/result.js